import React, { useEffect } from "react";
import { Table  } from 'antd';
import Card from "components/card";
import CrudOption from "components/dropdown/crudoption";
import { connect } from "react-redux";
import TrainingModuleRequestForm from "./TrainingModuleRequestForm";
import PopupButton from "components/button/PopupButton";
import { handleTableChange } from "../../../../utils/index";
import { 
	getTrainingModuleRequestList, 
	doTrainingModuleRequestDelete,
	doTrainingModuleRequestReset,
} from "../../../../redux/trainingmodulerequest/trainingModuleRequestState";
import SearchFilter from "components/search/SearchFilter";
import { MODULE_TRAINING_REQ } from "variables/constants";


const TrainingModuleRequestTable = ({
	recordList, 
	pagination, 
	doSearch, 
	filters, 
	doDelete,
	doRecordReset
}) => {


  	const columns = [
		{
	        title: `Title`,
	        dataIndex: 'tmr_title',
	        key: 'tmr_title',
	        width: '30%',
	        render:(trm_title) => <span>{trm_title}</span> 
	    },
		{
	        title: `Summary`,
	        dataIndex: 'tmr_summary',
	        key: 'tmr_summary',
	        width: '30%',
	        render:(tmr_summary) => <span>{tmr_summary}</span> 
	    },
		{
	        title: `Target Date`,
	        dataIndex: 'tmr_target_date',
	        key: 'tmr_target_date',
	        width: '14%',
	        render:(tmr_target_date) => <span>{tmr_target_date}</span> 
	    },
		{
			title: 'Requested By',
			dataIndex: 'requested_by',
			key: 'requested_by',
			width: '14%',
			render: (requested_by) => <span>{requested_by}</span>
  		},
	    {
	        title: <PopupButton id="add_trainingModuleRequest" title="Add Training Module Request" label="Add" btnClass="btn-small" action="add" moduleId={MODULE_TRAINING_REQ}>
						<TrainingModuleRequestForm recordId="0" mode="edit" />
					</PopupButton>,
	        dataIndex: 'tmr_id',
	        key: 'tmr_id',
	        width: '12%',
	        render:(_, record) => <CrudOption 
									baseRoute="/console/training-module-requests" 
									recordId={record?.tmr_id} 
									deleteHandler={doDelete} 
									editMode="modal"
									title="Edit Training Module"
									closeHandler={doRecordReset}
									editHandler={(recordId, doRecordReset ) => (
										<TrainingModuleRequestForm 
											recordId={recordId} 
											mode="edit" 
											onCancel={doRecordReset} 
										/>
									)}
								/>
	    },
    ];
    
	useEffect(() => {
		doSearch({paginate: pagination.per_page});
	}, [doSearch, pagination.per_page]);
	
  	return (
	    <Card extra={"w-full h-full p-4"}>
			<div className="py-2">
				<SearchFilter 
					placeholder="Search by Title" 
					searchHandler={doSearch} 
					filters={filters} 
					pagination={pagination}
				/>
			</div>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
				<Table
					dataSource={recordList} 
					columns={columns} 
					rowKey={(record) => record.tmr_id}
					scroll={{ x: "max-content" }}
					pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}    
					onChange={handleTableChange(doSearch, filters)}                	
				/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.trainingModuleRequest.trainingModuleRequestList?.items,
	pagination: state.trainingModuleRequest.trainingModuleRequestList?.pagination,
	filters: state.trainingModuleRequest.trainingModuleRequestList?.filters,
	requesting: state.trainingModuleRequest.trainingModuleRequestList?.requesting,
	error: state.trainingModuleRequest.trainingModuleRequestList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getTrainingModuleRequestList(filters)),
	doDelete: (id) => dispatch(doTrainingModuleRequestDelete(id)),
	doRecordReset: () => dispatch(doTrainingModuleRequestReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingModuleRequestTable);
